import React from 'react';
import { Activity } from '../types';
import userMessageStyles from './UserMessage.module.css';

export const LiveChatUserMessage: React.FC<{
    activity: Activity;
    idx: number;
}> = ({ activity, idx }) => {
    return (
        <div
            id={`liveChatUserMessage-${idx}`}
            key={'user-' + idx}
            className={userMessageStyles.userUtterance}
        >
            <div
                className={userMessageStyles.userUtteranceBubble}
                style={{ margin: 0 }}
            >
                {activity.value.text}
            </div>
        </div>
    );
};
